import { csrfToken } from 'rails-ujs';

$(() => {
  //▼ 投稿お気に入り登録・解除
  $('a.favorite_post').on('click', function () {
    var favorite = $(this);
    var wrap_div = favorite.parent("div");
    var post_id = favorite.data("post-id");
    var ballon = $("div.ballon-box");
    var tooltip = ballon.children("div.arrow_box");

    $.ajax({
      type: 'POST',
      url: '/api/favorite_posts/refresh',
      headers: {
        'X-CSRF-Token': csrfToken()
      },
      data: {
        "post_id": post_id
      }
    }).done(function () {
      if (wrap_div.hasClass("btn-fav-off")) {
        wrap_div.removeClass("btn-fav-off").addClass("btn-fav");
        tooltip.text("お気に入りに登録しました");
      } else {
        wrap_div.removeClass("btn-fav").addClass("btn-fav-off");
        tooltip.text("お気に入りを解除しました");
      }
      ballon.show();
      setTimeout(function () {
        ballon.hide();
      }, 2000);
    });
  });
});
